import { styled } from '@mui/material'

export const StyledImage = styled('img')(({ theme }) => ({
  maxHeight: 56,
  maxWidth: 112,
}))
